import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import BsyDashComponent from "../../dash/BsyDashComponent";
import "./index.css";
import "react-resizable/css/styles.css";
import _ from "lodash";
import SortableList from "./SortableList";
import { BsyUtils } from "../../../utils/Utils";

class BsyDashboardMyDash extends Component {
  static defaultProps = {
    myDash: {},
    onLayoutChange: function () {},
  };

  constructor(props) {
    super(props);
    this.state = {
      myDash: props.myDash,
    };
  }

  componentDidMount = () => {
    this.setState({}, () => {
      if (!BsyUtils.isObjectEmpty(this.state.myDash.dash)) {
        this.props?.onRefreshChars?.();
      }
    });
  };

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    // console.log('BsyDashboardMyDash UNSAFE_componentWillReceiveProps1',  )
    if (!_.isEqual(nextProps.myDash, this.state.myDash)) {
      // console.log('BsyDashboardMyDash UNSAFE_componentWillReceiveProps2',  )
      const { myDash } = nextProps;
      this.setState(
        {
          myDash: myDash,
        },
        () => {
          this.props?.onRefreshChars?.({ ...myDash });
        }
      );
    }
  }

  getComponent = (widgetId) => {
    const { myDash } = this.state;
    return myDash.dash.find((res) => res.widgetId === widgetId);
  };

  onDelComponent = (component, e) => {
    let el = BsyUtils.closestClass(e.target, "react-grid-item");
    if(el) {
      el.classList.remove("block-full-screen"); //全屏状态删除
    }
    if (this.props.onDelComponent) {
      this.props.onDelComponent(component);
    }
  };
  onGetStyles = (id) => { //拿的应用访问默认样式
    return JSON.parse('{"theme":{"name":"preset_style_light_1","highLightColor":"#0265FF","palette":"preset_1","gradation":"preset_map_1","color":"#E9E9E9","icon":1,"cardName":"preset_metric_1"},"background":{"type":"color","color":"#FFFFFF"},"fontSetting":{"titleColor":"#1F2D3D","headColor":"#5E6D82","textColor":"#1F2D3D","textAlign":"default"}}')
  };
  onItemsChange = (dash) => {
    const { myDash } = this.state;
    if (!_.isEqual(dash, myDash.dash)) {
      //   console.log("onItemsChange", JSON.stringify(dash));
      this?.props?.onItemsChange(dash);
    }
  };

  renderComponent = (component) => {
    if (!component) {
      return "";
    }
    switch (component.widgetType) {
      default:
        return (
          <BsyDashComponent
            widget={{
              ...component.widgetParams,
              widgetId: component.widgetId,
              appId: component.appId,
              entryId: component.entryId,
            }}
            onGetStyles={this.onGetStyles}
            env="dashboard"
            key={`BsyDashComponent1-${component.widgetId}`}
            onDelComponent={(e) => {
              this.onDelComponent(component, e);
            }}
            hasDelete={true}
            onIsAutoLoad={() => {
              return true;
            }}
          />
        );
    }
  };

  renderErrorComponent = (component) => {
    return (
      <div className="t-error-component">
        <i className="icon-bby-new-tip"></i>
        <div className="empty-text">组件配置异常</div>
        <div
          className="delete-btn"
          onClick={(e) => {
            this.onDelComponent(component, e);
          }}
        >
          <i className="icon-trasho"></i>
        </div>
      </div>
    );
  };

  render() {
    const { myDash } = this.state;

    return (
      <div className={"dashboard-my-dash"}>
        {BsyUtils.isObjectEmpty(myDash.dash) ? (
          <div className="dash-empty">
            <span className="dash-empty-title">
              {React.language("dash.mine.empty")}
            </span>
            <span className="dash-add-btn" onClick={this?.props?.onAddDash}>
              {React.language("add")}
            </span>
          </div>
        ) : (
          ""
        )}
        <SortableList
          style={{
            display: BsyUtils.isObjectEmpty(myDash.dash) ? "none" : "",
          }}
          initialItems={myDash?.dash || []}
          onItemsChange={this.onItemsChange}
          onRender={(res) => {
            const component = this.getComponent(res.widgetId);
            if (component) {
              if (_.isEmpty(component.widgetParams)) {
                return this.renderErrorComponent(component);
              } else {
                return this.renderComponent(component);
              }
            }
          }}
        />
      </div>
    );
  }
}

export default withRouter(BsyDashboardMyDash);
